import React from 'react'
import { Spacer } from '../atoms'
import { Button } from 'react-native-paper'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { helpers } from '@linqpal/common-frontend'
import { IconArrowBack } from '../../assets/icons'
import { useStore } from '../../store'
import { observer } from 'mobx-react-lite'
import { View } from 'react-native'

const { composeStyle } = helpers

type PropTypes = {
  onPress?: () => void
  disabled?: boolean
  containerStyle?: any
  buttonStyle?: any
  style?: any
  save?: boolean
  children?: string
  buttonProps?: any
  dontShowBack?: boolean
  onBack?: () => void
  document?: any
}

export const ButtonFlowNext = observer(
  ({
    onPress,
    disabled,
    containerStyle,
    buttonStyle,
    style,
    save,
    children = 'Next',
    buttonProps,
    dontShowBack,
    onBack,
    ...props
  }: PropTypes) => {
    const { userStore } = useStore()
    const document =
      props.document?.type === 'project_form'
        ? props.document
        : userStore.document

    return (
      <View
        style={composeStyle(
          {
            marginVertical: 20,
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingHorizontal: 18,
          },
          containerStyle,
        )}
        {...props}
      >
        {!dontShowBack && (
          <Button
            onPress={() => {
              if (onBack) {
                onBack()
              } else if (document.filled.length > 0) {
                document.moveBack()
              } else {
                document.setCurrent('review')
              }
            }}
          >
            <IconArrowBack />
          </Button>
        )}
        <Spacer />
        {onPress && (
          <Button
            disabled={disabled}
            buttonColor={commonColors.accentText}
            mode="contained"
            style={composeStyle({ borderRadius: 8, width: 150 }, buttonStyle)}
            contentStyle={{
              height: 48,
              padding: 16,
              borderRadius: 0,
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onPress={onPress}
            labelStyle={{ fontSize: 16 }}
            {...buttonProps}
          >
            {save ? 'Save' : children}
          </Button>
        )}
      </View>
    )
  },
)
